module.exports = __webpack_public_path__ + "static/media/main.b2328beb.scss";


//////////////////
// WEBPACK FOOTER
// ./src/styles/main.scss
// module id = 57
// module chunks = 0